/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination} from "swiper";

const swiper = new Swiper(".immodetailswiper", {
	modules: [Navigation, Pagination],
	grabCursor: true,
	loop: true,
	pagination: {
		el: '.swiper-pagination',
	},	
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1,
	spaceBetween: 0,
});
if(document.querySelector('[data-pdf]')) {
	document.querySelector('[data-pdf]').addEventListener('click',function(e) {
		e.preventDefault();
		const url = 'https://microservice.unternehmen-online.de/document/create?config=wesermarschd&target_url='+btoa(e.target.dataset['pdf']);
		window.open(url, '_blank');
	})
}


		









